import { useScrollReveal } from '../../hooks/useScrollReveal';

const STATS = [
  { value: '20+', label: 'Years Serving the GTA', icon: 'ri-history-line', sub: 'Est. 2002' },
  { value: '4.9★', label: 'HomeStars Rating', icon: 'ri-star-fill', sub: 'Verified Reviews' },
  { value: '24/7', label: 'Emergency Service', icon: 'ri-time-line', sub: 'Always Available' },
  { value: '100%', label: 'T.S.S.A. Certified', icon: 'ri-shield-check-line', sub: 'Ontario Approved' },
  { value: 'Free', label: 'In-Home Consultations', icon: 'ri-gift-line', sub: 'No Obligation' },
];

export default function TrustBar() {
  const { ref, visible } = useScrollReveal<HTMLElement>();

  return (
    <section
      ref={ref}
      className="relative overflow-hidden border-y border-luxury-gold/15"
      style={{ background: 'linear-gradient(90deg, #030D1F 0%, #071224 50%, #030D1F 100%)' }}
    >
      {/* Blue atmospheric glow */}
      <div className="absolute inset-0 pointer-events-none" style={{ background: 'radial-gradient(ellipse 60% 120% at 50% 50%, rgba(26,101,224,0.07) 0%, transparent 65%)' }} />

      <div className="max-w-[1500px] mx-auto px-6 lg:px-14 py-0">
        <div
          className={`transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
        >
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5">
            {STATS.map((item, i) => (
              <div
                key={item.value}
                className={`group flex items-center gap-4 py-7 px-6 lg:px-8 transition-all duration-300 hover:bg-luxury-gold/5 cursor-default ${
                  i < STATS.length - 1 ? 'border-r border-luxury-gold/10' : ''
                }`}
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                {/* Icon circle */}
                <div className="w-11 h-11 flex items-center justify-center flex-shrink-0 rounded-full border border-luxury-gold/25 bg-luxury-gold/10 group-hover:border-luxury-gold/50 group-hover:bg-luxury-gold/18 transition-all duration-300">
                  <i className={`${item.icon} text-luxury-gold text-base`} />
                </div>

                {/* Text */}
                <div className="min-w-0">
                  <div className="font-serif text-luxury-gold text-3xl font-bold leading-none whitespace-nowrap mb-1">
                    {item.value}
                  </div>
                  <div className="font-caps text-[9px] tracking-[0.18em] uppercase text-white whitespace-nowrap leading-tight">
                    {item.label}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
